import * as React from 'react'
import { Box } from "@mui/material"


export default function priceChangesColumn(name, label) {
	return {
		name: name, label: label,
		options: {
			filter: false,
			customBodyRowRenderLite: value => <Box sx={{ textAlign: 'center' }}>
                {value}
            </Box>
		}
	}
}